/**
 * @module events/types/selectionChange
 */

/**
 * @type {string}
 */
export default 'selectionchange'
